import { AuthResponse } from "./models/auth.models";
import axiosInstance from "./axios";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

// post azure ad code to backend to get bearer token
export const fetchBearerToken = async (code: string): Promise<AuthResponse> => {
  try {
    const response = await axiosInstance.post(`${apiUrl}/token/entra`, {
      code,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch bearer token:", error);
    throw error;
  }
};

export const loginAsNormalUser = async (
  email: string,
  password: string
): Promise<AuthResponse> => {
  try {
    const response = await axiosInstance.post(`${apiUrl}/token`, {
      email,
      password,
    });
    return response.data;
  } catch (error) {
    console.error("Failed to login:", error);
    throw error;
  }
};
